import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Badge } from '../Badge';
import { Row } from '../Layout/Row';
import { Typography } from '../Typography';
import styles from './RecordCard.module.scss';
export const SUPERSEDED_BY = '\u2192';
export const typographyPropsOf = (source)=>({
        variant: source === null || source === void 0 ? void 0 : source.variant,
        skin: source === null || source === void 0 ? void 0 : source.skin,
        weight: source === null || source === void 0 ? void 0 : source.weight,
        ellipsis: source === null || source === void 0 ? void 0 : source.ellipsis
    });
const supersededAmountOf = (struckAmount, separator, testId)=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph3",
                skin: "secondary",
                className: styles.struck,
                testId: testId,
                children: struckAmount
            }),
            separator === 'arrow' && /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph3",
                skin: "secondary",
                children: SUPERSEDED_BY
            })
        ]
    });
export const totalRowOf = (param)=>{
    let { id, label, amount, struckAmount, supersededSeparator = 'none', aside, asideVariant = 'paragraph3', isStruck, dividerAbove, labelVariant, labelWeight, skin, testIds } = param;
    return {
        id,
        spread: true,
        dividerAbove,
        dividerSkin: 'subtle',
        label: {
            hideColon: true,
            text: label,
            variant: labelVariant !== null && labelVariant !== void 0 ? labelVariant : 'paragraph3',
            weight: labelWeight,
            skin
        },
        value: /*#__PURE__*/ _jsxs(Row, {
            gap: 8,
            alignItems: "baseline",
            children: [
                struckAmount != null && supersededAmountOf(struckAmount, supersededSeparator, testIds === null || testIds === void 0 ? void 0 : testIds.struckAmount),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    weight: "normal",
                    skin: skin,
                    className: isStruck ? styles.struck : undefined,
                    testId: testIds === null || testIds === void 0 ? void 0 : testIds.amount,
                    children: amount
                }),
                aside != null && /*#__PURE__*/ _jsx(Typography, {
                    variant: asideVariant,
                    skin: "secondary",
                    testId: testIds === null || testIds === void 0 ? void 0 : testIds.aside,
                    children: aside
                })
            ]
        })
    };
};
export const lineRowOf = (param)=>{
    let { key, id, name, amount, struckAmount, supersededSeparator = 'none', badge, badgeSkin, gap, variant, labelVariant, shrinkable, isStruck, skin, testIds } = param;
    return {
        key,
        id,
        spread: true,
        label: {
            hideColon: true,
            shrinkable,
            variant: labelVariant,
            text: /*#__PURE__*/ _jsxs(Row, {
                gap: gap,
                alignItems: "center",
                className: shrinkable ? styles.lineDetails : undefined,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: variant,
                        skin: skin,
                        className: isStruck ? styles.struck : undefined,
                        testId: testIds.name,
                        children: name
                    }),
                    badge != null && /*#__PURE__*/ _jsx(Badge, {
                        size: "small",
                        skin: badgeSkin,
                        outlined: true,
                        rounded: true,
                        testId: testIds.badge,
                        children: badge
                    })
                ]
            })
        },
        value: /*#__PURE__*/ _jsxs(Row, {
            gap: 8,
            alignItems: "baseline",
            children: [
                struckAmount != null && supersededAmountOf(struckAmount, supersededSeparator, testIds.struckAmount),
                amount != null && /*#__PURE__*/ _jsx(Typography, {
                    variant: variant,
                    skin: skin,
                    className: isStruck ? styles.struck : undefined,
                    testId: testIds.amount,
                    children: amount
                })
            ]
        })
    };
};
